import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="relative mt-24 border-t border-omny-purple/20">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-omny-purple/5 to-omny-purple/10 pointer-events-none"></div>
      <div className="container mx-auto px-6 py-12 relative">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold">OMNY</h3>
            <p className="text-gray-400">Transforming DeFi with AI-powered cross-chain solutions.</p>
            <div className="flex space-x-4">
              <a href="https://x.com/OmnyFinance" className="text-gray-400 hover:text-omny-purple transition">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-omny-purple transition">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0C5.374 0 0 5.374 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.237 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.626-5.374-12-12-12z"/>
                </svg>
              </a>
            
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-400 hover:text-omny-purple transition">About</Link></li>
              <li><Link to="/features" className="text-gray-400 hover:text-omny-purple transition">Features</Link></li>
              <li><Link to="/nft-tokenomics" className="text-gray-400 hover:text-omny-purple transition">NFT & Tokenomics</Link></li>
              <li><Link to="/governance" className="text-gray-400 hover:text-omny-purple transition">Governance</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-bold mb-4">Resources</h4>
            <ul className="space-y-2">
              <li><Link to="/education" className="text-gray-400 hover:text-omny-purple transition">Education Hub</Link></li>
              <li><a href="#" className="text-gray-400 hover:text-omny-purple transition">Documentation</a></li>
              <li><a href="#" className="text-gray-400 hover:text-omny-purple transition">API Reference</a></li>
              <li><a href="#" className="text-gray-400 hover:text-omny-purple transition">Platform Status</a></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-bold mb-4">Stay Updated</h4>
            <p className="text-gray-400 mb-4">Subscribe to our newsletter for the latest updates.</p>
            <form className="space-y-2" onSubmit={(e) => e.preventDefault()}>
              <input 
                type="email" 
                placeholder="Enter your email" 
                className="w-full px-4 py-2 bg-omny-dark/50 rounded-lg border border-omny-purple/30 focus:border-omny-purple focus:outline-none"
              />
              <button type="submit" className="w-full bg-omny-purple px-4 py-2 rounded-lg hover:bg-opacity-90 transition">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>© {new Date().getFullYear()} OMNY. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 